const angular = require('angular');
const moment = require('moment');
const app = angular.module('learn-directives');
/**
 * Defines the related events component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('relatedEvents', ['Events', function (Events) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      chosenEvents: '='
    },
    template: require('../../../templates/directives/cms/related-events.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.directory = {};

      self.addEvent = function() {
        if (!$scope.chosenEvents) {
          $scope.chosenEvents = [];
        }
        for (var i = 0; i < $scope.chosenEvents.length; i++) {
          if ($scope.chosenEvents[i].toString() === self.titleAdd.toString()) {
            self.titleAdd = null;
            return;
          }
        }
        $scope.chosenEvents.push(self.titleAdd);
        self.titleAdd = null;
      };

      self.removeEvent = function(index) {
        if (!$scope.chosenEvents) {
          return;
        }
        $scope.chosenEvents.splice(index, 1);
      };

      self.initialize = function() {
        self.titlesLoad = true;

        Events.find({
          fields: 'title,start_date',
          start_date: '$gt,date-' + moment().format('MM-DD-YY'),
          sort: 'title,1'
        }).$promise
        .then(function(items) {
          self.titles = [];
          angular.forEach(items, function(item) {
            self.directory[item._id] = item;
            self.titles.push({
              name: item.title,
              value: item._id
            })
          });
          self.titlesLoad = false;
        });
      };

      self.initialize();
    }],
    controllerAs: 'related'
  };
}]);
